"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    tooltip: {
        backgroundColor: '#FEFFDE',
        color: 'black',
        border: '1px solid black',
        maxWidth: 500,
    },
}));
//# sourceMappingURL=tooltip-styles.js.map